module.exports = __webpack_public_path__ + "img/cloud-icon.b0a634e5.svg";